import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../contexts/CurrencyContext';
import { cn } from '../../lib/cn';

const ALLOWED_CURRENCIES = ['GBP', 'USD', 'CAD', 'AUD', 'EUR', 'IRR'];

const DISPLAY_NAMES: Record<string, string> = {
  USD: 'USD ($)',
  EUR: 'EUR (€)',
  GBP: 'GBP (£)',
  CAD: 'CAD (C$)',
  AUD: 'AUD (A$)',
  IRR: 'IRR (تومان)',
};

export function CurrencySelector({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { currency, setCurrency, rates, loading } = useCurrency();

  if (loading || rates.length === 0) return null;

  const availableCodes = ['IRR', ...new Set(rates.map((r) => r.currency_code))].filter(
    (code) => ALLOWED_CURRENCIES.includes(code)
  );

  return (
    <select
      value={currency}
      onChange={(e) => setCurrency(e.target.value)}
      aria-label={t('currency.selectorLabel')}
      className={cn(
        'px-2.5 py-1.5 rounded-lg border border-border bg-surface text-sm text-text-secondary',
        'hover:border-text-muted focus:outline-none focus:ring-1 focus:ring-brand-primary transition-colors',
        className
      )}
    >
      {availableCodes.map((code) => (
        <option key={code} value={code}>
          {DISPLAY_NAMES[code] || code}
        </option>
      ))}
    </select>
  );
}
